const createHierarchyList = {
  methods: {
    createHierarchyList(categories) {
      // Mark each category as top level
      categories.forEach(category => category.level = 0);

      // Start with alphabetical sort
//     categories = categories.sort((a,b) => a.name < b.name ? -1 : 1);

      // Get all sub-categories
      const subs = categories.filter(category => category.parent);

      // Remove all sub-categories
      categories = categories.filter(category => !category.parent);

      // Insert sub-categories back where they belong
      // We go backwards in array so we can delete subs if they are placed in category array
      // We keep going until the array of subs is empty, i.e. we've placed them all
      while (subs.length) {
        for (let i = subs.length-1; i >= 0; i--) {
          const sub = subs[i];
          const parentIndex = categories.findIndex(category => sub.parent.id === category.id);
          if (parentIndex !== -1) {
            sub.level = categories[parentIndex].level + 1;      // Level is one deeper than parent
            categories.splice(parentIndex+1, 0, sub);
            subs.splice(i, 1);
          }
        }
      }

      return categories;
    }
  }
}

export default createHierarchyList;